import { render, staticRenderFns } from "./Requisitos.vue?vue&type=template&id=6b3f2c78&"
import script from "./Requisitos.vue?vue&type=script&lang=js&"
export * from "./Requisitos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports